module.exports = __webpack_public_path__ + "static/media/levain_bg_img_2.b1e232d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider/levain_bg_img_2.jpg
// module id = 1057
// module chunks = 0